import { PathHelper } from '@sensenet/client-utils';
import { ODataUrlBuilder } from "./ODataUrlBuilder.js";
export class AllowedChildTypes {
  add(idOrPath, contentTypes) {
    return this.repository.executeAction({
      idOrPath,
      name: 'AddAllowedChildTypes',
      method: 'POST',
      body: {
        contentTypes
      }
    });
  }
  update(idOrPath, contentTypes) {
    return this.repository.patch({
      idOrPath,
      content: {
        AllowedChildTypes: contentTypes
      }
    });
  }
  remove(idOrPath, contentTypes) {
    return this.repository.executeAction({
      idOrPath,
      name: 'RemoveAllowedChildTypes',
      method: 'POST',
      body: {
        contentTypes
      }
    });
  }
  getFromCTD(idOrPath) {
    return this.repository.executeAction({
      idOrPath,
      name: 'GetAllowedChildTypesFromCTD',
      method: 'GET',
      body: {
        select: ['Name', 'DisplayName', 'Icon']
      }
    });
  }
  listEmpty(idOrPath) {
    return this.repository.executeAction({
      idOrPath,
      name: 'CheckAllowedChildTypesOfFolders',
      method: 'GET'
    });
  }

  /**
   * Retrieves an aggregated list of content types the user can create as children below the given content
   * @param {LoadOptions<ContentType>} options
   */
  async get(options) {
    const allowedTypes = {
      d: {
        __count: 0,
        results: []
      }
    };
    await Promise.all([this.getImplicit(options), this.getExplicit(options)]).then(([implicitACTs, explicitACTs]) => {
      allowedTypes.d.results = implicitACTs.d ? implicitACTs.d.results.filter(ct => !explicitACTs.d.results.find(contenttype => ct.Name === contenttype.Name)).concat(explicitACTs.d.results) : [];
      allowedTypes.d.__count = allowedTypes.d.results.length;
    });
    return allowedTypes;
  }

  /**
   * Retrieves a list of content types the user can create as children below the given content (allowed on the content)
   * @param {LoadOptions<ContentType>} options Options for fetching the AllowedChildTypes
   */
  async getImplicit(options) {
    const contextPath = PathHelper.getContentUrl(options.idOrPath);
    const params = ODataUrlBuilder.buildUrlParamString(this.repository.configuration, options.oDataOptions);
    const path = PathHelper.joinPaths(this.repository.configuration.repositoryUrl, this.repository.configuration.oDataToken, contextPath, 'AllowedChildTypes');
    const response = await this.repository.fetch(`${path}?${params}`, {
      credentials: 'include',
      method: 'GET'
    });
    if (!response.ok) {
      throw await this.repository.getErrorFromResponse(response);
    }
    return await response.json();
  }

  /**
   * Retrieves a list of content types the user can create as children below the given content (allowed in the CTD)
   * @param {LoadOptions<ContentType>} options Options for fetching the AllowedChildTypes
   */
  async getExplicit(options) {
    const contextPath = PathHelper.getContentUrl(options.idOrPath);
    const params = ODataUrlBuilder.buildUrlParamString(this.repository.configuration, options.oDataOptions);
    const path = PathHelper.joinPaths(this.repository.configuration.repositoryUrl, this.repository.configuration.oDataToken, contextPath, 'EffectiveAllowedChildTypes');
    const response = await this.repository.fetch(`${path}?${params}`, {
      credentials: 'include',
      method: 'GET'
    });
    if (!response.ok) {
      throw await this.repository.getErrorFromResponse(response);
    }
    return await response.json();
  }
  constructor(repository) {
    this.repository = repository;
  }
}
//# sourceMappingURL=AllowedChildTypes.js.map